module.exports = __webpack_public_path__ + "static/media/stats.23da1a63.svg";